import gql from 'graphql-tag'

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($newPassword: String!, $recoveryToken: String!) {
    updatePassword(newPassword: $newPassword, recoveryToken: $recoveryToken) {
      token
    }
  }
`
